import React from "react";
import { Layout, PageHeader } from "@/components/Layout";
import { api } from "@/lib/api";
import { UploadWorkspace } from "@/components/UploadWorkspace";

export default function Upload() {
  return (
    <Layout>
      <PageHeader title="Subir archivo" subtitle="Sube una imagen o PDF y elige qué hacer con él" />
      <div className="p-8">
        <UploadWorkspace client={api} tokenKey="admin_token" jobsPath="/jobs" />
      </div>
    </Layout>
  );
}
